import { SkyBannerPropTypes } from './prop-types';

const namespace = 'ui-search-sidebar-placements';

export { SkyBannerPropTypes, namespace };
